import { createContext } from 'react';
const ProductConfigurationContext = createContext(undefined);
export const ProductConfigurationConsumer = ProductConfigurationContext.Consumer;
export default ProductConfigurationContext;
//# sourceMappingURL=ProductConfigurationContext.js.map